<template>
  <!-- 预约购药 -->
  <div class="order-buy-drug">
    <!-- 配送地址 -->
    <div class="info-card">
      <div class="card-header">配送地址</div>
      <div
        v-if="currentAddress.receiver_name"
        class="address-info-content"
        @click="gotoAddressListFn"
      >
        <div class="left-address-info">
          <img src="../assets/images/addressIcon.png" class="address-icon" />
          <div class="address-info-text">
            <div class="user-info">
              {{ currentAddress.receiver_name }} {{ currentAddress.receiver_phone }}
            </div>
            <p class="user-address">
              {{ currentAddress.receiver_address }}
            </p>
          </div>
        </div>
      
        <div class="right-arrow-icon">更换地址 ></div>
        <!-- <img src="../assets/images/rightArrow.png" class="right-arrow-icon" /> -->
      </div>
      <div v-else class="no-address-card">
        <van-icon name="location-o" color="#208fe3" size="30" style="margin-top: 6px;" />
        <!-- <img src="../assets/images/location.png" class="no-card-icon"> -->
        <div class="no-card-tip">您还没有地址哦～</div>
        <van-button @click="addNewAddressFn" class="add-address-btn">新增地址</van-button>
      </div>
    </div>
    <!-- 就诊信息 -->
    <!-- <div class="info-card">
      <div class="card-header">就诊信息</div>
      <ul class="user-info-content">
        <li class="user-info-item">
          <div class="user-info-label">患者</div>
          <div class="user-info-text">{{ recipeInfo.name }} {{ recipeInfo.sex }} {{recipeInfo.age}}岁</div>
        </li>
        <li class="user-info-item">
          <div class="user-info-label">本次诊断</div>
          <div class="user-info-text">{{ recipeInfo.diagnoseStr }}</div>
        </li>
        <li class="user-info-item">
          <div class="user-info-label">手机号</div>
          <div class="user-info-text">{{recipeInfo.phone}}</div>
        </li>
      </ul>
    </div> -->
    <!-- 下一步 -->

    <div class="bottom-info-box" v-if="currentAddress.id > 0">
      <!-- 提交按钮 -->
      <van-button class="next-btn" @click="gotoOrderDetailFn">下一步</van-button>
    </div>
  </div>
</template>

<script>
import { Button as vanButton, Icon as vanIcon, Toast as VanToast } from 'vant';
import wx from 'weixin-js-sdk';
import axios from '../services/recipe';
import address from '../services/address';
import areaList from '../lib/area';

export default {
  name: 'OrderBuyDrug',
  data() {
    return {
      // 地址列表
      addressList: [],
      // 当前地址
      currentAddress: {},
      // 用户信息
      userInfo: {},
      // 处方笺信息
      recipeInfo: [],
      areaList: {}
    };
  },
  created() {
    this.areaList = areaList;
    this.getAddressListFn();
    this.getPrescriptionInfo();
  },
  components: {
    vanButton,
    vanIcon
  },
  methods: {
    // 获取收获地址列表
    getAddressListFn() {
      address
        .getUserAddressList({ patient_id: this.$store.getters.getUserInfo.patientId })
        .then(res => {
          if (res.data.status === 'success') {
            this.addressList = res.data.data;
            if (this.addressList.length > 0) {
              let addressItem = {};
              if (this.$route.query.id) {
                this.addressList.forEach(item => {
                  if (item.id === this.$route.query.id) {
                    addressItem = item;
                    // return;
                  }
                });
              } else {
                addressItem = this.addressList[0];
              }
              const _item = {};

              _item.receiver_name = addressItem.receiver_name;
              _item.receiver_phone = addressItem.receiver_phone;
              _item.receiver_address =
                this.areaList.province_list[addressItem.receiver_province] +
                this.areaList.city_list[addressItem.receiver_city] +
                this.areaList.county_list[addressItem.receiver_area] +
                addressItem.receiver_address;
              _item.id = addressItem.id;
              this.currentAddress = _item;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取处方笺信息
    getPrescriptionInfo() {
      console.log('this.$route.params');
      console.log(this.$route.params);

      const params = {
        recipeId: this.$route.params.id
      };
      axios.getRecipeInfo(params).then(res => {
        // console.log(res);

        if (res.data.data.status && res.data.data.status === 'success') {
          this.recipeInfo =
            res.data.data.data instanceof Array ? res.data.data.data : [res.data.data].data;

          const orderDetailStatus = ['2', '3', '4', '6'];
          const totalPrice = res.data.totalPrice || 0;

          // if (this.recipeInfo[0].useStatus == 1) {
          //   VanToast.success('订单已存在，正在前往订单支付页');
          //   setTimeout(() => {
          //     this.$router.push({
          //       path: '/pay',
          //       query: {
          //         orderNum: this.recipeInfo[0].orderNum,
          //         price: totalPrice,
          //       },
          //     });
          //   }, 1000);
          // } else
          if (
            this.recipeInfo[0].useStatus == 2 ||
            this.recipeInfo[0].useStatus == 3 ||
            this.recipeInfo[0].useStatus == 4
          ) {
            VanToast.success('订单已存在，正在前往订单详情页');
            // console.log('订单已存在，正在前往订单详情页')
            setTimeout(() => {
              this.$router.push({
                path: `/orderDetail/${this.recipeInfo[0].recipeId}/${this.recipeInfo[0].orderNum}`,
                query: {
                  addressId: this.recipeInfo[0].addressId
                }
              });
            }, 1000);
          } else if (this.recipeInfo[0].useStatus == '7') {
            VanToast.success('订单已过期');
            setTimeout(() => {
              // this.$router.push({
              //   path: `/prescription/${this.recipeInfo[0].recipeId}`
              // });
              wx.closeWindow();
            }, 1000);
          } else if (this.recipeInfo[0].useStatus == '10') {
            VanToast.success('订单已作废');
            setTimeout(() => {
              wx.closeWindow();
            }, 1000);
          }
        }
      });
    },
    // 新增地址
    addNewAddressFn() {
      this.$router.push({
        path: '/addressItem/0',
        query: {
          recipeId: this.$route.params.id,
          url: this.$route.path
        }
      });
    },
    // 切换地址
    gotoAddressListFn() {
      this.$router.push({
        path: '/addressList',
        query: {
          id: this.$route.params.id,
          url: this.$route.path
        }
      });
    },
    // 下一步
    gotoOrderDetailFn() {
      this.$router.push({
        path: `/orderDetail/${this.$route.params.id}/0`,
        query: {
          addressId: this.currentAddress.id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.order-buy-drug {
  padding: 15px;
}
.info-card {
  border-radius: 8px;
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  .card-header {
    height: 30px;
    border-bottom: 1px solid #ebebeb;
    font-size: 17px;
    color: #333;
    font-weight: bold;
  }
  .user-info-item {
    height: 30px;
    line-height: 30px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .user-info-text {
      width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: right;
    }
  }
  .address-info-content {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    .left-address-info {
      display: flex;
    }
    .address-icon {
      width: 30px;
      height: 30px;
      vertical-align: middle;
    }
    .address-info-text {
      display: inline-block;
      margin-left: 10px;
      vertical-align: middle;
      .user-info {
        margin-bottom: 7px;
        font-size: 16px;
        color: #333;
      }
      .user-address {
        font-size: 13px;
        color: #999;
      }
    }
    .right-arrow-icon {
      width: 30%;
      color: #208fe3;
      margin-top: 12px;
      position: relative;
      .icon{
        width: 14px;
        position: absolute;
        right: 0px;
        top: 3px;
      }
    }
  }
  .no-address-card {
    text-align: center;
    .no-card-icon {
      width: 35px;
      height: 35px;
      margin-top: 18px;
    }
    .no-card-tip {
      font-size: 13px;
      color: #208fe3;
      margin-top: 6px;
    }
    .add-address-btn {
      width: 140px;
      height: 41px;
      background: #208fe3;
      border-radius: 4px;
      font-size: 17px;
      line-height: 18px;
      margin-top: 24px;
      color: #ffffff;
      margin-bottom: 10px;
    }
  }
}
.bottom-info-box {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 9;
  height: 90px;
  // width: calc(100% - 30px);
  width: 100%;
  background: #fff;
  padding: 15px;
  text-align: center;
  .next-btn {
    font-size: 18px;
    background: #208fe3;
    border-radius: 4px;
    border: none;
    width: 100%;
    color: #fff;
  }
}
</style>
